import { Box, Flex, Text, Textarea } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { HintBox } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/ManageKYC/ReviewKycWorkflow/component/StepContent/component/RightPanel/component/Review/component/styled.ts';
import { TEST_ELEMENT_IDS } from '@dealstack/shared/tests/testElementIds';

interface Props {
	comment: string;
	commentError: string;
	onCommentChange: (comment: string) => void;
	addCommentText: string;
	placeholder?: string;
	disabled?: boolean;
}

export const CommentInput = ({
	comment,
	commentError,
	addCommentText,
	onCommentChange,
	placeholder = 'Add a comment...',
	disabled = false,
}: Props) => {
	const tMipManage = useTranslationMipManage();

	return (
		<Flex direction="column" gap="0.5rem">
			<HintBox>
				<Icon variant="information" />
				<Text fw={600}>{tMipManage('kyc.review.comment_hint')}</Text>
			</HintBox>
			<Text fw={600}>{addCommentText}</Text>
			<Box
				data-testid={TEST_ELEMENT_IDS.MIP_MANAGE_KYC_REVIEW_REJECT_COMMENT_INPUT}
				style={{ display: 'contents' }}
			>
				<Textarea
					value={comment}
					onChange={(e) => onCommentChange(e.target.value)}
					placeholder={placeholder}
					error={commentError}
					disabled={disabled}
					autosize
					minRows={4}
					maxRows={8}
				/>
			</Box>
		</Flex>
	);
};
